import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';


const Error404 = (props) => {
    return (
        <div className="error">
            <div className="contain">
                <div className="errorpage">
                    <div className="details">
                        <img src="./svg/404 svg.svg" />
                        <span>متاسفانه صفحه مورد نظر یافت نشد</span>
                        <Link to="/" className="btn-base btn-black btn-sircle">
                            <Button
                                variant="contained">بازگشت به صفحه اصلی</Button>
                        </Link>
                    </div>
                    <div className="vector">
                        <img src="./svg/blob.svg" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Error404;